/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import PaginatedListState from 'flarum/common/states/PaginatedListState';
export default class AchievementUsersListState extends PaginatedListState {
  constructor(levelId) {
    super({}, 1, 30);
    this.levelId = levelId;
  }
  get type() {
    // PaginatedListState uses `type` as the request path, so the nested route goes here whole.
    return 'achievement_levels/' + this.levelId + '/users';
  }

  // Core's loadPage passes no request options, so silencing its default error alert means issuing the request
  // ourselves. The suppression covers every page: the page owns the error surface for the refresh (Placeholder)
  // and for loadNext (inline message in its onclick), so core's alert would only duplicate them.
  // Params are built as core does so requestParams()/mutateRequestParams() hooks keep applying.
  loadPage(page) {
    if (page === void 0) {
      page = 1;
    }
    const reqParams = this.requestParams();
    const include = Array.isArray(reqParams.include) ? reqParams.include.join(',') : reqParams.include;
    const params = {
      ...reqParams,
      page: {
        ...reqParams.page,
        offset: this.pageSize && this.pageSize * (page - 1) || 0,
        limit: this.pageSize || undefined
      },
      include
    };
    if (typeof params.include === 'undefined') {
      delete params.include;
    }
    return app.store.find(this.type, this.mutateRequestParams(params, page), undefined, {
      errorHandler: () => {}
    }).then(results => {
      const usedPerPage = results.payload?.meta?.perPage;
      const usedTotal = results.payload?.meta?.page?.total;
      if (!this.pageSize || usedPerPage && this.pageSize !== usedPerPage) {
        this.pageSize = usedPerPage || PaginatedListState.DEFAULT_PAGE_SIZE;
      }
      if (!this.totalItems || usedTotal && this.totalItems !== usedTotal) {
        this.totalItems = usedTotal || null;
      }
      return results;
    });
  }
}
flarum.reg.add('glowingblue-gamilytics', 'forum/achievements/states/AchievementUsersListState', AchievementUsersListState);